import personal from './personal'

export default {
  personal
}
